import { queensFire, ForestBow } from 'helpers/abilities';
import { AMULET, CRYSTAL, QUEENSFIRE, FOREST_BOW } from 'helpers/constants';

/**** Item Template ***

Item Hooks (entry points to the game)
 - Init
 - onMove
     - description: called from within the moveUnitToTile, the logic change after the animation.
     - (scene, unit, destination, origin) => new Promise(resolve => resolve())
 - afterEachTurn
     - description: called before setting up the next team's turn, calling ai, or allowing input from player
     - (scene, lastPiece, lastColor) => new Promise(resolve => resolve())
 - preMoveButton
    - makes piece.itemActive = true
 - aim (projectile)
    - set up the targetable tiles, set click to collect a target selection
 - fire (projectile)
    - when target selection is made during aim step this will be run, should trigger the main effect of the item.
 - serverFire (projectile)
    - triggers main effect of the item, using server-sode logic. (indexMap, no animations, immutable)
*/

const ITEM_LIST = {
  1: {
    id: 1,
    name: 'Armor',
    description: 'The wearer can withstand a hit before begin captured.',
    class: 'any',
    type: 'hitpoints',
    amount: 2,
    spriteIndex: CRYSTAL,
    miniSpriteIndex: 1,
    init: (scene, tile, pieceSprite) => {
      pieceSprite.hp = 2;
      if (scene && scene.pieceMap && scene.pieceMap[pieceSprite.id]) {
        scene.pieceMap[pieceSprite.id].hp = 2;
      }
    }
  },
  // 2: {
  //   id: 2,
  //   name: 'Polarity Renouncer',
  //   description: 'Allows a bishop to move laterally one space',
  //   class: 'bishop',
  //   type: '5x5grid',
  //   spriteIndex: 464,
  //   miniSpriteIndex: 3,
  //   grid: [
  //     ['a', -1, -1, -1, 'c'],
  //     [-1, 3, 1, 3, -1],
  //     [-1, 1, 0, 1, -1],
  //     [-1, 3, 1, 3, -1],
  //     ['f', -1, -1, -1, 'h']
  //   ]
  // },
  4: {
    id: 4,
    name: 'Queensfire',
    description: "Leaves a trail of fire behind the queen's movements",
    class: 'queen',
    type: 'turn-limited-effect',
    spriteIndex: QUEENSFIRE,
    miniSpriteIndex: 2,
    preMoveButton: { label: 'Queensfire', action: () => {} },
    trigger: 'move',
    onMove: (scene, unit, destination, origin) =>
      new Promise(resolve => {
        if (unit.itemActive) {
          unit.itemActive = false;
          if (!scene.fireSets) {
            scene.fireSets = [];
          }
          scene.fireSets.push(queensFire(scene.map, origin, destination));
        }
        resolve(true);
      })
  },
  5: {
    id: 5,
    name: 'Forest Bow',
    description: 'Grow trees where arrows are shot.',
    class: 'any',
    type: 'projectile',
    spriteIndex: FOREST_BOW,
    miniSpriteIndex: 5,
    trigger: 'button',
    charges: 1,
    init: scene => ForestBow.init(scene),
    preMoveButton: {
      label: 'Seed Shot',
      action: (scene, originTile) => ForestBow.aim(scene, originTile),
      cancel: scene => ForestBow.cancel(scene)
    },
    fire: (scene, originTile, targetTile, cb) =>
      ForestBow.fire(scene, originTile, targetTile, cb),
    serverFire: (room, actionData) => ForestBow.serverFire(room, actionData)
  },
  7: {
    id: 7,
    name: "Gma's Amulet",
    description: '???',
    class: 'fayette',
    type: 'hitpoints',
    spriteIndex: AMULET,
    miniSpriteIndex: 0,
    amount: 2,
    init: (scene, tile, pieceSprite) => {
      pieceSprite.hp = 2;
      if (scene && scene.pieceMap && scene.pieceMap[pieceSprite.id]) {
        scene.pieceMap[pieceSprite.id].hp = 2;
      }
    }
  }
};

export default ITEM_LIST;
